module.exports = __webpack_public_path__ + "assets/a2287ec33bf700d411a478d18f4d7c44.mp3";